export default __webpack_public_path__ + "static/media/caret.d9460608.svg";